var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3025 4.03096L11.9692 2.69692L13.3232 1.34221L14.6572 2.67625L13.3025 4.03096ZM3.52997 13.8033L2.99065 13.9286L2.07132 13.0092L2.19666 12.4699L11.0219 3.64428L12.3552 4.97832L3.52997 13.8033ZM15.6045 1.71222L14.2872 0.395512C13.7599 -0.131837 12.9032 -0.131837 12.3759 0.395512L0.978656 11.7939L0 16L4.20662 15.0213L15.6045 3.62361C16.1318 3.09626 16.1318 2.23957 15.6045 1.71222Z",
    fill: "#4D4D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.bf716f9f361c15b6afc16e603f0c23cf.svg";
export { ForwardRef as ReactComponent };